import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Brain, Wind, Home } from 'lucide-react';
export function SolutionSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      {/* La Verdad Simple */}
      <section className="py-24 px-4 bg-[#FAF8F5] relative overflow-hidden" data-id="element-217">
        <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-white to-transparent opacity-50" data-id="element-218"></div>

        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-219">
          <FadeIn data-id="element-220">
            <h2 className="text-3xl md:text-4xl font-serif text-[#3D3D3D] mb-8" data-id="element-221">
              La verdad simple
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-222">
            <p className="text-xl text-[#5A6B5A] mb-8" data-id="element-223">
              Cuando estás saturada, no necesitas más teoría.
            </p>
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-[#E5E0D8] inline-block text-left" data-id="element-224">
              <p className="text-lg text-[#3D3D3D] font-medium mb-4" data-id="element-225">
                Necesitas un{' '}
                <span className="text-[#C4836A]" data-id="element-226">ritual mínimo</span> que:
              </p>
              <ul className="space-y-3 text-[#5A6B5A]" data-id="element-227">
                <li className="flex items-center gap-3" data-id="element-228">
                  <span className="w-2 h-2 rounded-full bg-[#8B9E8B]" data-id="element-229"></span>
                  Puedas hacer aunque estés cansada
                </li>
                <li className="flex items-center gap-3" data-id="element-230">
                  <span className="w-2 h-2 rounded-full bg-[#8B9E8B]" data-id="element-231"></span>
                  Baje el volumen del cuerpo
                </li>
                <li className="flex items-center gap-3" data-id="element-232">
                  <span className="w-2 h-2 rounded-full bg-[#8B9E8B]" data-id="element-233"></span>
                  Cierre bucles mentales
                </li>
                <li className="flex items-center gap-3" data-id="element-234">
                  <span className="w-2 h-2 rounded-full bg-[#8B9E8B]" data-id="element-235"></span>Y
                  quite fricción del entorno
                </li>
              </ul>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Product Reveal */}
      <section className="py-20 px-4 bg-white" data-id="element-236">
        <div className="max-w-6xl mx-auto" data-id="element-237">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-238">
            <FadeIn direction="right" data-id="element-239">
              <div className="relative" data-id="element-240">
                <div className="absolute inset-0 bg-[#8B9E8B]/10 rounded-3xl transform rotate-3 scale-105" data-id="element-241"></div>
                <img src="https://cdn.magicpatterns.com/uploads/rJ4ywGyDSgYrgaD2PvMPjr/Antiansiedad_AD1.png" alt="Agenda Antiansiedad de 14 Días" className="relative rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" data-id="element-242" />
              </div>
            </FadeIn>

            <div className="space-y-8" data-id="element-243">
              <FadeIn direction="left" data-id="element-244">
                <span className="text-[#C4836A] font-semibold tracking-wide uppercase text-sm" data-id="element-245">
                  Presentando
                </span>
                <h2 className="text-4xl md:text-5xl font-serif text-[#3D3D3D] mt-2 mb-6" data-id="element-246">
                  Agenda Antiansiedad <br data-id="element-247" />
                  de 14 Días
                </h2>
                <p className="text-lg text-[#5A6B5A] leading-relaxed" data-id="element-248">
                  Un ebook práctico para recuperar calma y enfoque usando el{' '}
                  <strong data-id="element-249">Protocolo 3×3×3</strong>. Con guiones y plantillas
                  listas, para vida real.
                </p>
              </FadeIn>

              {/* Protocol 3x3x3 */}
              <div className="space-y-4" data-id="element-250">
                <FadeIn delay={0.2} data-id="element-251">
                  <div className="flex items-center p-4 bg-[#FAF8F5] rounded-xl border border-[#E5E0D8]" data-id="element-252">
                    <div className="w-12 h-12 rounded-full bg-[#C4836A]/10 flex items-center justify-center text-[#C4836A] flex-shrink-0 mr-4" data-id="element-253">
                      <Wind size={24} data-id="element-254" />
                    </div>
                    <div data-id="element-255">
                      <h4 className="font-bold text-[#3D3D3D]" data-id="element-256">
                        3 minutos CUERPO
                      </h4>
                      <p className="text-sm text-[#5A6B5A]" data-id="element-257">
                        Bajas activación física
                      </p>
                    </div>
                  </div>
                </FadeIn>

                <FadeIn delay={0.3} data-id="element-258">
                  <div className="flex items-center p-4 bg-[#FAF8F5] rounded-xl border border-[#E5E0D8]" data-id="element-259">
                    <div className="w-12 h-12 rounded-full bg-[#8B9E8B]/10 flex items-center justify-center text-[#8B9E8B] flex-shrink-0 mr-4" data-id="element-260">
                      <Brain size={24} data-id="element-261" />
                    </div>
                    <div data-id="element-262">
                      <h4 className="font-bold text-[#3D3D3D]" data-id="element-263">
                        3 minutos MENTE
                      </h4>
                      <p className="text-sm text-[#5A6B5A]" data-id="element-264">
                        Cierras bucles mentales
                      </p>
                    </div>
                  </div>
                </FadeIn>

                <FadeIn delay={0.4} data-id="element-265">
                  <div className="flex items-center p-4 bg-[#FAF8F5] rounded-xl border border-[#E5E0D8]" data-id="element-266">
                    <div className="w-12 h-12 rounded-full bg-[#3D3D3D]/5 flex items-center justify-center text-[#3D3D3D] flex-shrink-0 mr-4" data-id="element-267">
                      <Home size={24} data-id="element-268" />
                    </div>
                    <div data-id="element-269">
                      <h4 className="font-bold text-[#3D3D3D]" data-id="element-270">
                        3 minutos ENTORNO
                      </h4>
                      <p className="text-sm text-[#5A6B5A]" data-id="element-271">
                        Reduces fricción visual
                      </p>
                    </div>
                  </div>
                </FadeIn>
              </div>

              <FadeIn delay={0.5} data-id="element-272">
                <div className="pt-4" data-id="element-273">
                  <p className="text-xl font-serif text-[#3D3D3D] mb-6" data-id="element-274">
                    9 minutos en total. 2 veces al día.
                  </p>
                  <Button size="lg" onClick={scrollToPricing} data-id="element-275">
                    Quiero empezar hoy
                  </Button>
                </div>
              </FadeIn>
            </div>
          </div>
        </div>
      </section>
    </>;
}